// removed by extract-text-webpack-plugin
module.exports = {"classtop-custom-dock":"classtop-custom-dock","classtop-table":"classtop-table","notResizable":"notResizable","action-title":"action-title","close-button":"close-button","closingTag":"closingTag","dock-content":"dock-content","dock-body":"dock-body","dock-footer":"dock-footer","dock-header":"dock-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Dock/Dock.scss
// module id = wrrq
// module chunks = 0